var cov_13dpxxctlt = function () {
  var path = "/Users/spana/SHEIN/shineout/src/icons/Caret.tsx",
      hash = "45f2302b25d2380be185f23860923c630cce2fcd",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/icons/Caret.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 48
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 13,
          column: 49
        }
      },
      "2": {
        start: {
          line: 13,
          column: 20
        },
        end: {
          line: 13,
          column: 49
        }
      },
      "3": {
        start: {
          line: 14,
          column: 2
        },
        end: {
          line: 14,
          column: 37
        }
      },
      "4": {
        start: {
          line: 14,
          column: 19
        },
        end: {
          line: 14,
          column: 37
        }
      },
      "5": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 15,
          column: 62
        }
      },
      "6": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 39
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 26
          },
          end: {
            line: 12,
            column: 27
          }
        },
        loc: {
          start: {
            line: 12,
            column: 32
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 12
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 49
          }
        }, {
          start: {
            line: 13,
            column: 2
          },
          end: {
            line: 13,
            column: 49
          }
        }],
        line: 13
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 37
          }
        }, {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 37
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 16,
            column: 9
          },
          end: {
            line: 16,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 9
          },
          end: {
            line: 16,
            column: 20
          }
        }, {
          start: {
            line: 16,
            column: 24
          },
          end: {
            line: 16,
            column: 39
          }
        }],
        line: 16
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import icons from './index';
import config from '../config';
import configable from '../hoc/config';
import cssAccessor from '../utils/css-accessors';
var cachedCaret;
var caretMap = (cov_13dpxxctlt.s[0]++, {
  line: icons.CaretLine,
  fill: icons.CaretFill
});
export default configable(function () {
  cov_13dpxxctlt.f[0]++;
  cov_13dpxxctlt.s[1]++;

  if (config.caret) {
    cov_13dpxxctlt.b[0][0]++;
    cov_13dpxxctlt.s[2]++;
    return caretMap[config.caret];
  } else {
    cov_13dpxxctlt.b[0][1]++;
  }

  cov_13dpxxctlt.s[3]++;

  if (cachedCaret) {
    cov_13dpxxctlt.b[1][0]++;
    cov_13dpxxctlt.s[4]++;
    return cachedCaret;
  } else {
    cov_13dpxxctlt.b[1][1]++;
  }

  cov_13dpxxctlt.s[5]++;
  cachedCaret = caretMap[cssAccessor.common.caret];
  cov_13dpxxctlt.s[6]++;
  return (cov_13dpxxctlt.b[2][0]++, cachedCaret) || (cov_13dpxxctlt.b[2][1]++, icons.CaretFill);
}, 'caret');